import { render, staticRenderFns } from "./DetailsAuditDialog.vue?vue&type=template&id=d8870782&scoped=true"
import script from "./DetailsAuditDialog.vue?vue&type=script&lang=js"
export * from "./DetailsAuditDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailsAuditDialog.vue?vue&type=style&index=0&id=d8870782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8870782",
  null
  
)

export default component.exports